module.exports = __webpack_public_path__ + "static/media/empty_performances.90fd1a25.png";